import * as core from '../../../../../../../core'

import { query } from './pi-table-no-idc-funding.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.pi-table',
    description:
      'Displays a list of PIs in a table widget without Award Funding, IDC, or related metrics',
    name: 'RP Explore - PIs Table',
    query,
    variables: [
      {
        id: 'projects',
        name: 'Projects',
        type: {
          dimensionId: 'dim::!projects',
          isMultiselect: true,
        },
      },
      {
        id: 'mtdcMin',
        name: 'MTDC Minimum',
        type: core.common.value.types.Intrinsic.Currency,
      },
      {
        id: 'mtdcMax',
        name: 'MTDC Maximum',
        type: core.common.value.types.Intrinsic.Currency,
      },
      {
        id: 'mtdcDensityMin',
        name: 'MTDC Density Minimum',
        type: core.common.value.types.Intrinsic.Currency,
      },
      {
        id: 'mtdcDensityMax',
        name: ' MTDC Density Maximum',
        type: core.common.value.types.Intrinsic.Currency,
      },
      {
        id: 'asfMin',
        name: 'ASF Minimum',
        type: core.common.value.types.Intrinsic.Decimal,
      },
      {
        id: 'asfMax',
        name: 'ASF Maximum',
        type: core.common.value.types.Intrinsic.Decimal,
      },
      {
        id: 'effectiveRecoveryMin',
        name: 'Effective Recovery Minimum',
        type: core.common.value.types.Intrinsic.Percent,
      },
      {
        id: 'effectiveRecoveryMax',
        name: 'Effective Recovery Maximum',
        type: core.common.value.types.Intrinsic.Percent,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
